import { GraphQLObjectType, GraphQLString } from 'graphql';
import { TypeNames } from '../../types';
var UserPlace = new GraphQLObjectType({
  fields: {
    cloudId: {
      type: GraphQLString
    },
    name: {
      type: GraphQLString
    }
  },
  name: TypeNames.USER_ORGANIZATION,
  description: 'Organization a user belongs to'
});
export default UserPlace;